module.exports = __webpack_public_path__ + "img/2021-09-26.67e2bce6.jpg";